/**
 *
 * Created by Jan Bradac on 26.4.2016.
 */

// TODO Moba II - Ajax::ImproveProtocol - Unify the Ajax response sending and receiving.
(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Ajax = Lfl.Ajax || {};

    (function (Ajax, $, undefined) {
        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Parses response sent by the server based on application protocol defined by this class and the PHP class
         * AjaxResponseWrapper.
         * @memberOf Lfl.Ajax
         */
        Lfl.Ajax.ResponseParser = Ajax.ResponseParser || {};

        (function (ResponseParser, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */
            /**
             * The prefix used in response to mark section where javascript that should be moved is.
             * @type {string}
             */
            var JAVASCRIPT_ID_PREFIX = "javascript-section";
            var MODALS_ID_PREFIX = "modals-section";
            var PRIMARY_RESPONSE_HTML_ID_PREFIX = "primary-response-html";

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            // TODO MOBA II - Ajax::ImproveProtocol - add the possibility to return the HtmlSections instead of
            //      appending them to $printablesLocation.

            /**
             * Handles the content returned by AjaxResponseWrapper
             * @memberOf Lfl.Ajax.ResponseParser
             * @param $element The element received from server
             * @param $printablesLocation The location where HTML should be moved.
             */
            ResponseParser.parseAjaxResponseWrapperData = function ($element, $printablesLocation) {

                /*
                 |-------------------------------------------------------------------------
                 | Move HTML */

                _.each(ResponseParser.getPrimaryHtmlSections($element), function ($printable, key) {
                    $printablesLocation.append($printable);
                });

                /*
                 |-------------------------------------------------------------------------
                 | Move modals
                 | If the response contains modal dialogues, then they should be moved to
                 | the appropriate part of page. */

                ResponseParser.moveModals($element);

                /*
                 |-------------------------------------------------------------------------
                 | Process Javascript
                 | The element might contain javascript - evaluate it and move it to
                 | correct section on the page.*/

                // See: Ajax::ImproveProtocol::IsEvalAnIssue
                eval($element);
                ResponseParser.moveJavascript($element);
            };

            /**
             * Handles the content returned from server
             * @memberOf Lfl.Ajax.ResponseParser
             * @param ajaxResponseWrapperData The data received from
             * @param printablesLocation
             */
            ResponseParser.parseAjaxResponse = function (ajaxResponseWrapperData, printablesLocation) {
                // TODO Moba II - Ajax::ImproveProtocol - unify protocol how to call and encode parts of the response
                //      Needs cooperation with PHP AjaxResponseWrapper
                throw "Not implemented yet.";

                /*
                 |-------------------------------------------------------------------------
                 | Move specific sections */

                // Flash messages

                // Others


            };

            /**
             * Takes javascript and other scripts out from the provided html code and moves it to appropriate section on the page.
             *
             * @param $html A HTML code wrapped in jquery wrapper
             *
             * @memberOf Lfl.Ajax.ResponseParser
             */
            ResponseParser.moveJavascript = function ($html) {
                $html.children().each(function (index) {
                    var $child = $(this);
                    var id = $child.attr('id');

                    if (id.indexOf(JAVASCRIPT_ID_PREFIX) !== -1) {
                        // The child's id denotes that this section contains a script that should be moved to js section
                        $child.detach();
                        var jsSection = Lfl.PageSectionsManager.getJavascriptSection();
                        jsSection.append($child);
                    }
                });
            };

            /**
             * Takes modal dialogues out from the provided html code and moves them to appropriate section on the page.
             *
             * @param $html A HTML code wrapped in jquery wrapper
             *
             * @memberOf Lfl.Ajax.ResponseParser
             */
            ResponseParser.moveModals = function ($html) {
                $html.children().each(function (index) {
                    var $child = $(this);
                    var id = $child.attr('id');

                    if (id.indexOf(MODALS_ID_PREFIX) !== -1 && isEmpty($child) === false) {
                        // The child's id denotes that it contains a modal dialogue to be moved and it is not empty.
                        $child.detach();

                        $child.children().each(function (index) {
                            Lfl.Modals.Displayer.appendBootstrapModal($(this));
                        });
                    }
                });
            };

            /**
             * Takes flash messages from provided JSON and displays them in the appropriate section on the page.
             *
             * TODO MOBA II - Ajax::ImproveProtocol - more than one message sent back does not make sense!
             *      Refactor to expect only one message and log warning if multiple are present.
             * - And create a PHP counterpart, which will add FlashMessage to json response.
             * -- Probably an entire AjaxResponseBuilder
             * --- TODO AjaxResponseBuilder
             * @param response A JSON object
             * @deprecated In favor of parseFlashMessage
             *
             * @memberOf Lfl.Ajax.ResponseParser
             */
            ResponseParser.parseFlashMessages = function (response) {
                if (_.has(response, Lfl.PageSectionsManager.getFlashMessagesSectionIdentifier())) {
                    Lfl.FlashMessages.Displayer.displayAll(response[Lfl.PageSectionsManager.getFlashMessagesSectionIdentifier()]);
                }
            };

            /**
             * Takes the flash message from provided JSON and displays it in the appropriate section on the page.
             *
             * TODO MOBA II, TODO AjaxResponseBuilder - Finish this...
             *
             * @memberOf Lfl.Ajax.ResponseParser
             */
            ResponseParser.parseFlashMessage = function (response) {
                if (_.has(response, 'flash-message')) {
                    Lfl.FlashMessages.Displayer.display(response['flash-message']);
                }
            };


            /**
             * Parses out the primary HTML sections contained inside the response. The primary HTML is usually the part
             * that should be printed into the page's body, but it's content can vary based on the application protocol
             * of the specific client code using this parser.
             *
             * @param $html
             * @return {Array}
             *
             * @memberOf Lfl.Ajax.ResponseParser
             */
            ResponseParser.getPrimaryHtmlSections = function ($html) {
                var primaryHtmlSections = [];
                var i = 0;

                $html.children().each(function (index) {
                    var $child = $(this);
                    var id = $child.attr('id');

                    if (typeof id === 'undefined') {
                        return;
                    }

                    if (id.indexOf(PRIMARY_RESPONSE_HTML_ID_PREFIX) !== -1) {
                        $child.detach();

                        if ($child.children().length > 1) {
                            // TODO how to handle multiple children? Returning an array would break client code. Append them to each other?
                            console.warn("Beware, the wrapped HTML code has multiple children but only the first one will be returned. The wrapped HTML is:");
                            console.warn($child);
                        }

                        primaryHtmlSections[i++] = $($child.children()[0]);
                    }
                });

                if (i === 0) {
                    console.warn("The html did not contain any primary HTML sections. Please make sure that the content" +
                        "sent back from the server is wrapped correctly. You should use the AjaxResponseWrapper class.\n" +
                        "This issue can easily occur if the script is terminated with dd() or other die() variant."
                    );
                }

                return primaryHtmlSections;
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Form submitting
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Processes form submission success data.
             *
             * @memberOf Lfl.Ajax.ResponseParser
             * @param response The response data sent by the server.
             * @param $form The form which was submitted.
             */
            ResponseParser.processFormSubmissionSuccessResponse = function (response, $form) {
                clearAllPreviousErrors($form);

                ResponseParser.parseFlashMessages(response);
            };

            /*
             |-------------------------------------------------------------------------
             | Error responses
             | TODO - refactor into own class. ErrorCodesProvider? */

            // Client error
            var BAD_REQUEST_CODE = 400;
            var UNAUTHORIZED_CODE = 401;
            var FORBIDDEN_CODE = 403;
            var UNPROCESSABLE_ENTITY_CODE = 422;

            // Server error
            var INTERNAL_SERVER_ERROR = 500;
            var NOT_IMPLEMENTED_ERROR = 501;
            var SERVICE_UNAVAILABLE = 503;

            var ERROR_UNAUTHENTICATED = 'Unauthenticated.';

            var ERROR_ICON = "warning";
            var ERROR_MODAL_CLASS = 'error-modal';

            /**
             * @memberOf Lfl.Ajax.ResponseParser
             * @param response The response data sent by the server.
             */
            ResponseParser.processErrorResponse = function (response) {
                var header;
                var message;

                /*
                 |-------------------------------------------------------------------------
                 | Client error messages */

                if (response.status === UNPROCESSABLE_ENTITY_CODE) {
                    console.warn("Received status code " + UNPROCESSABLE_ENTITY_CODE + ", which should be handled by" +
                        "form submission handling method");
                }

                /* TODO LANG - in JS */

                if (response.status === UNAUTHORIZED_CODE) {
                    ResponseParser.reloadIfUnauthenticated(response);
                    return;
                }

                if (response.status === FORBIDDEN_CODE) {
                    header = 'Chyba: nedostatečné oprávnění.';
                    message = 'K tomuto kroku nemáte dostatečné oprávnění.\nPokud myslíte, že byste měli mít dostatečná oprávnění, zkuste se, prosíme, odhlásit a znovu přihlásit. \nZa případné komplikace se omlouváme.';
                    Lfl.Modals.Displayer.createBootstrapModalFromText(message, header, false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
                    return;
                }

                if (errorIsFromCategory(BAD_REQUEST_CODE, response.status)) {
                    header = 'Chyba v požadavku';
                    message = 'Je nám líto, ale zdá se, že na server dorazila chybná data.\nProsíme, zkuste zkontrolovat stránku, zda jsou formuláře správně vyplněné a případně zkuste stránku načíst znovu a akci zopakovat.\nZa případné komplikace se omlouváme.';
                    Lfl.Modals.Displayer.createBootstrapModalFromText(message, header, false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
                    return;
                }

                /*
                 |-------------------------------------------------------------------------
                 | Server error messages */

                if (response.status === NOT_IMPLEMENTED_ERROR) {
                    header = 'Chyba: tato funkce ještě není zprovozněna';
                    message = 'Omlouváme se, ale server hlásí, že tato funkce ještě není plně dokončená a proto ji není možné používat. Prosíme, zkuste znovu načíst stránku, nebo požadavek opakovat později.';
                    Lfl.Modals.Displayer.createBootstrapModalFromText(message, header, false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
                    return;
                }


                if (response.status === SERVICE_UNAVAILABLE) {
                    header = 'Chyba: služba je nedostupná';
                    message = 'Omlouváme se, ale server hlásí, že tato služba (nebo celý server) není v současné době dostupná. Prosíme, zkuste znovu načíst stránku, nebo požadavek opakovat později.';
                    Lfl.Modals.Displayer.createBootstrapModalFromText(message, header, false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
                    return;
                }

                if (errorIsFromCategory(INTERNAL_SERVER_ERROR, response.status)) {
                    header = 'Chyba serveru';
                    message = "Omlouváme se, ale na serveru nastala interní chyba. Prosíme, zkuste znovu načíst stránku, nebo požadavek opakovat později.";
                    Lfl.Modals.Displayer.createBootstrapModalFromText(message, header, false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
                    return;
                }

                //Fallback
                Lfl.Modals.Displayer.createBootstrapModalFromText(response, 'Chyba', false, 'large', ERROR_ICON, ERROR_MODAL_CLASS);
            };

            /**
             * Processes error data related to form submission request.
             *
             * @memberOf Lfl.Ajax.ResponseParser
             * @param response The response data sent by the server.
             * @param $form The form which was submitted.
             */
            ResponseParser.processFormSubmissionErrorResponse = function (response, $form) {

                // First we solve form related errors

                console.warn("== Received error response. It was: ==");
                console.warn(response);

                if (response.status === UNPROCESSABLE_ENTITY_CODE) {
                    clearAllPreviousErrors($form);
                    // Display errors.

                    // We received data from Laravel containing errors in the format "input field name (not id!)":
                    // "error message", so we loop through them and display them.
                    _.each(response.responseJSON, function (message, inputName) {
                        displayErrorMessage($form, inputName, message);
                    });

                    scrollInputIntoView(response, $form);

                    return;
                }

                // TODO only call if no errors was found, since the processErrorResponse should have some sort of
                // "Oops an unknown error occured with code X. Please try again.", if no other way to handle the error
                // was found.

                // Then we process the data as a regular error response

                ResponseParser.processErrorResponse(response);
            };

            ResponseParser.reloadIfUnauthenticated = function (xhr) {
                if (xhr.status === UNAUTHORIZED_CODE) {
                    location.reload();
                }
            }

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            var FORM_ERROR_CLASS = 'lfl-form-error';

            function clearAllPreviousErrors($form) {
                $form.find('.' + FORM_ERROR_CLASS).each(function (i, child) {
                    $(child).remove();
                });
            }

            function reportNonexistentInput(message, inputName) {
                alert("Omlouváme se, ale při ukládání formuláře se vyskytla chyba. " + /* TODO LANG - in JS */
                    "Zdá se, že server vyžaduje vyplnění položky, která ve formuláři chybí. (" +
                    message + ")");
            }

            function displayErrorMessage($form, inputName, message) {
                // create div with class and text
                // Append it to form.find(inputName) - google how to find input by name

                var input = getInputGroupInForm($form, inputName);


                var $input = $(input);

                if (typeof $input === 'undefined') {
                    reportNonexistentInput(message, inputName);
                    return false;
                } else {
                    $input.after('<div class="' + FORM_ERROR_CLASS + '" >' + message + '</div>');
                    return true;
                }
            }

            function getInputGroupInForm($form, inputName) {
                var input = $form.find("[name='" + inputName + "']")[0];

                if (typeof input === 'undefined') {
                    //The input might be an array so we have to add braces to the name (laravel does not send that correctly).
                    input = $form.find("[name='" + inputName + "[]']")[0];
                }

                var group = $(input).closest('.form-group');
                return group;
            }

            function scrollInputIntoView(response, $form) {
                //Focus the first one.
                var firstInputName = Object.keys(response.responseJSON)[0];

                var $inputGroup = $(getInputGroupInForm($form, firstInputName));

                if (typeof $inputGroup === 'undefined') {
                    console.warn('Input ' + firstInputName + " from response " + response + " is undefined");
                    return;
                }


                var parentModal = $form.closest('.modal');

                if (typeof parentModal === 'undefined') {
                    //It is not part of a modal dialogue

                    //We use [0] because we need the actual DOM element
                    $inputGroup[0].scrollIntoView({behavior: "smooth"});
                } else {
                    var $modalContent = $($(parentModal).find('.modal-content'));
                    //Note: sadly this does not work 100% fine, because the element has incorrect offset because of the
                    //bootstrap modal wrapper
                    var modalRect = $modalContent[0].getBoundingClientRect(),
                        elemRect = $inputGroup[0].getBoundingClientRect(),
                        offset = elemRect.top - modalRect.top;

                    $(parentModal).animate({
                        scrollTop: offset
                    }, 1000);
                }

            }

            /**
             *
             * @param categoryBaseCode - The base code for such a category (400 for client error, 500 for server error, ...)
             * @param errorCode
             */
            function errorIsFromCategory(categoryBaseCode, errorCode) {
                var diff = (errorCode - categoryBaseCode);
                return diff >= 0 && diff < 100;
            }

            function isEmpty($el) {
                return !$.trim($el.html())
            }

        }(Ajax.ResponseParser, jQuery))
    }(Lfl.Ajax, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
